// eslint-disable-next-line no-restricted-imports
import { EnablePageState, State } from 'modules';
// eslint-disable-next-line no-restricted-imports
import { isLoggedIn } from 'selectors/session';

export const isPowerUpsDirectoryLoading = (state: State): boolean =>
  (isLoggedIn(state) && state.ui.powerUpsDirectory.loadingHeader) ||
  state.ui.powerUpsDirectory.loadingPlugins;

export const getEnablePageState = (state: State): EnablePageState =>
  state.ui.powerUpsDirectory.enablePage;

export const getPowerUpDirectoryNavigationState = (state: State): boolean =>
  state.ui.powerUpsDirectory.navigationExpanded;



// WEBPACK FOOTER //
// ./app/gamma/src/selectors/power-ups-directory.ts